import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { WhatsAppButton } from "./components/site/WhatsAppButton";
import HomePage from "./pages/HomePage";
import ResidencialPage from "./pages/ResidencialPage";
import EmpresarialPage from "./pages/EmpresarialPage";
import ServicosPage from "./pages/ServicosPage";
import SobreNosPage from "./pages/SobreNosPage";
import ContactosPage from "./pages/ContactosPage";
import PrivacidadePage from "./pages/PrivacidadePage";
import AdminPage from "./pages/AdminPage";
import NotFoundPage from "./pages/NotFoundPage";

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = undefined; };
  }, []);
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = () => (
  <>
    <a href="#conteudo" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-gold focus:px-5 focus:py-3 focus:text-forest">Saltar para o conteúdo</a>
    <Header />
    <main id="conteudo"><Outlet /></main>
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/solucoes-residenciais" element={<ResidencialPage />} />
          <Route path="/solucoes-empresariais" element={<EmpresarialPage />} />
          <Route path="/servicos" element={<ServicosPage />} />
          <Route path="/sobre-nos" element={<SobreNosPage />} />
          <Route path="/contactos" element={<ContactosPage />} />
          <Route path="/pedir-orcamento" element={<ContactosPage quote />} />
          <Route path="/politica-de-privacidade" element={<PrivacidadePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
